export default {
      id: "Icon--jumpBack-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--jumpBack",
      toString: function () {
        return this.url;
      }
    }